import VueTypes, { nullable } from 'vue-types';

export const typeCheckbox = 'checkbox';
export const typeRadio = 'radio';
export const filterTypes = [typeCheckbox, typeRadio];
export const priceRange = VueTypes.arrayOf(Number).def([]);

// MODEL: FilterParameterItem
export const FilterParameterItem = VueTypes.shape({
    title: VueTypes.string.isRequired,
    keyword: VueTypes.string.isRequired,
    active: VueTypes.bool.isRequired,
    id: VueTypes.number.isRequired
}).isRequired;

// MODEL: FilterParameter
export const FilterParameter = VueTypes.shape({
    title: VueTypes.string.isRequired,
    keyword: VueTypes.string.isRequired,
    options: VueTypes.arrayOf(FilterParameterItem).isRequired,
    type: VueTypes.oneOf(filterTypes).def(filterTypes[0]),
    id: VueTypes.number.isRequired
}).isRequired;

// MODEL: PriceRangeLimits
export const PriceRangeLimits = VueTypes.shape({
    from: VueTypes.oneOfType([Number, nullable]).def(null),
    to: VueTypes.oneOfType([Number, nullable]).def(null)
}).isRequired;

export const createFilterCheckboxItem = ({ title, keyword, active, id }) => {
    return {
        title: title,
        keyword: keyword,
        active: active,
        id: id
    };
};

export const createFilterParameter = ({ title, keyword, options, type, id }) => {
    return {
        title: title,
        keyword: keyword,
        options: options,
        type: type,
        id: id
    };
};

export const handleCategoryFilters = categoryFilters => {
    const updatedCategoryFilters = categoryFilters.map(category => {
        return {
            ...category,
            value: category.id,
            title: category.name
        };
    });

    return [
        {
            id: 'categoryId',
            // id: 'categoryId',
            title: 'category',
            sp_key: 'categoryId',
            type: 'checkbox',
            options: updatedCategoryFilters
        }
    ];
};

export const handleBrandsFilters = brandsFilters => {
    const updatedBrandsFilters = brandsFilters.map(brand => {
        return {
            ...brand,
            sp_key: parseFloat(brand.id),
            value: brand.id,
            title: brand.name
        };
    });

    return [
        {
            id: 'brand_id',
            // filterId: 'brand_id',
            title: 'brandsTitle',
            sp_key: 'brand_id',
            type: 'checkbox',
            options: updatedBrandsFilters
        }
    ];
};
